import * as ActionType from "./notification.type";
import { apiClient } from "../../../api/client";
import { setToast } from "../../../util/toast";

export const SendSellerNotification = (formData, sellerId) => async (dispatch) => {
  const res = await apiClient.post(
    `/notification/particularSeller?sellerId=${sellerId}`,
    formData
  );

  if (res.ok && res.data?.status) {
    setToast("success", "Notification sent successfully to Seller");
    dispatch({
      type: ActionType.SEND_SELLER_NOTIFICATION,
      payload: { data: res.data.message, id: sellerId },
    });
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const sendAllNotification = (formData, type) => async (dispatch) => {
  const res = await apiClient.post(
    `/notification/send?notificationType=${type}`,
    formData
  );

  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.SEND_NOTIFICATION, payload: res.data });
    setToast("success", `Notification Sent Successfully to ${type}`);
  } else {
    setToast("error", res.data?.message || res.message);
  }
};
